import { render, staticRenderFns } from "./CreateGroup.vue?vue&type=template&id=430f555f&scoped=true&lang=html&"
import script from "./CreateGroup.vue?vue&type=script&lang=js&"
export * from "./CreateGroup.vue?vue&type=script&lang=js&"
import style0 from "./CreateGroup.vue?vue&type=style&index=0&id=430f555f&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430f555f",
  null
  
)

export default component.exports